import ScheduleForm from 'components/ScheduleForm'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { DialogTitle } from '@mui/material';
import { BootstrapDialog } from './subUsers/AddSubUsers';

export const AddEncounterModal= ({ item, afterUpdated, onClose, show, isDuplicate, isEdit }) => {
    const dispatch = useDispatch();

    // const refCloseScheduleButton = React.useRef(null);


    const handleCloseScheduleForm = () => {
        // refCloseScheduleButton.current.click();
        onClose(item?.id, item?.status);
    }



    return (
        <BootstrapDialog
            fullWidth={true}
            maxWidth={"md"}
            onClose={onClose}
            aria-labelledby="customized-dialog-title"
            open={show}


        >
            <div className="">
                <div className="modal-content full_modal">
                    <DialogTitle>
                        <div className="modal-header header_modal align-items-center">
                            <div></div>
                            <h5 className="modal-title_u">{isEdit ? `Edit Job # ${item?.appid}` : 'Create New Job'}</h5>
                            <button type="button" className="btn-close"
                                // ref={refCloseScheduleButton} data-bs-dismiss="modal" 
                                aria-label="Close"
                                onClick={
                                    () => {
                                        onClose(item?.id, item?.status);
                                    }
                                }

                            ></button>
                        </div>
                    </DialogTitle>
                    <div className="modal-body modal_form_body">
                        <ScheduleForm handleClose={handleCloseScheduleForm}
                            item={item}
                            isDuplicate={isDuplicate}
                            itsBootstrap={false}
                            afterUpdated={() => {
                                afterUpdated(item?.id, item?.status)
                            }} />
                    </div>
                </div>
            </div>
        </BootstrapDialog>
    )
}
